import React from 'react'
import { Button, DropdownMenu, Flex, Text, useAppTheme } from '@workwhile/ui'
import { AccordionCard } from 'components/AccordionCard'
import { InfoTable } from 'components/InfoTable'
import { useRuleDetailContextValue } from '../context/RuleDetailProvider'
import { useRuleDetailWorkflowsContextValue } from '../context/RuleDetailWorkflowsProvider'
import {
  Calendar,
  CalendarOff,
  EllipsisVertical,
  Layers,
  Link,
  Pencil,
} from 'lucide-react'

const SCOPE_LABELS: Record<string, string> = {
  full: 'Full',
  unincorporated_only: 'Unincorporated only',
}

export const RuleInfoCard = () => {
  const { space } = useAppTheme()
  const {
    state: { effectiveStart, effectiveEnd, coverageScope, reference },
  } = useRuleDetailContextValue()

  const { editRuleFlow } = useRuleDetailWorkflowsContextValue()

  return (
    <AccordionCard
      title={
        <Flex
          justifyContent="space-between"
          alignItems="center"
          gap={2}
          width="100%"
        >
          <Text fontSize={2} color="lightText">
            Details
          </Text>
          <DropdownMenu
            trigger={
              <Button
                variant="secondary"
                kind="small"
                style={{ paddingLeft: space[1], paddingRight: space[1] }}
              >
                <EllipsisVertical size={14} />
              </Button>
            }
          >
            <DropdownMenu.Item onClick={editRuleFlow.open}>
              <Flex as="span" alignItems="center" style={{ gap: 8 }}>
                <Pencil size={14} />
                Edit
              </Flex>
            </DropdownMenu.Item>
          </DropdownMenu>
        </Flex>
      }
      size="small"
    >
      <InfoTable>
        <InfoTable.Row
          icon={<Calendar size={14} />}
          label="Effective start"
          value={effectiveStart}
        />
        <InfoTable.Row
          icon={<CalendarOff size={14} />}
          label="Effective end"
          value={effectiveEnd ?? <Text color="lightText">Open-ended</Text>}
        />
        <InfoTable.Row
          icon={<Layers size={14} />}
          label="Coverage scope"
          value={SCOPE_LABELS[coverageScope] ?? coverageScope}
        />
        {reference ? (
          <InfoTable.Row
            icon={<Link size={14} />}
            label="Reference"
            value={reference}
          />
        ) : null}
      </InfoTable>
    </AccordionCard>
  )
}
